import $api from '@/api'
import { defineStore } from 'pinia'

export const useIndex = defineStore('index', {
  state: () => ({
    requestInfo: {
      error: 0,
      message: ''
    },
  }),
  actions:{
    setRequestInfo(info:any) {
      this.requestInfo = info;
    },
  }
})

export const useAlone = defineStore('alone', {
  // other options...
  state: () => ({
    sessionId:'',
    isLogin: null,
    user: {}
  }),
  actions:{
    getLoginStatus() { // 获取登录状态
      return new Promise((resolve) => {
          if (this.isLogin != null) {
              resolve(this.isLogin)
              return
          }
          $api.aloneApi.getLoginStatus().then((res:any) => {
              if (res.code === 200) {
                this.setLoginStatus(res.data.loginStatus)
                resolve(res.data.loginStatus)
              }else{
                resolve(false)
              }
          })
      })
    },
    setLoginStatus(isLogin: any) {
      this.isLogin = isLogin
    },
    setUserInfo(user: any) {
        this.user = user
    },
    setSessionId(sessionId = '') {
      this.sessionId = sessionId
      localStorage.setItem('sessionId', sessionId)
    },
    initUser(){  // 清空用户信息
      return new Promise((resolve) => {
        this.setLoginStatus(false)
        this.setUserInfo({})
        localStorage.setItem('sessionId','')
        this.setSessionId('')
        resolve(true)
      })
    },
  }
})

